import { get } from '../../../helpers/axios';

const BASE_PATH = '/campaign-message/dashboard';
const BASE_ANNUAL_PATH = '/campaign-message/dashboard-annual';

const BASE_PATH_BUSINESS = '/business';
//# API DE SERVICIOS PARA MODULO SHORTCODES

export const getDashboardData = (businessId, startDate,endDate) => get(`${BASE_PATH}/${businessId}?initDate=${startDate}&limitDate=${endDate}`);

export const getDashboardAnnualData = (businessId, year) => get(`${BASE_ANNUAL_PATH}/${businessId}?year=${year}`);

export const getAllActiveBusiness = () => get(`${BASE_PATH_BUSINESS}/active`);


